// extracted by mini-css-extract-plugin
module.exports = {"description":"Home_description__pkdND","posts":"Home_posts__x_cMq","partners":"Home_partners__YdVu7","textHeader":"Home_textHeader__SCnFf"};